import { render } from "./CompletionQuestionView.vue?vue&type=template&id=2393a5da"
import script from "./CompletionQuestionView.vue?vue&type=script&lang=js"
export * from "./CompletionQuestionView.vue?vue&type=script&lang=js"

import "./CompletionQuestionView.vue?vue&type=style&index=0&id=2393a5da&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__